var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editor)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('editor-content',{attrs:{"editor":_vm.editor}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }